export default __webpack_public_path__ + "static/media/trash-bin.c6a76db7.svg";